import type * as Types from '~/api/schema.graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ChangesetDiffQueryVariables = Types.Exact<{
  changeset: Types.Scalars['ID']['input'];
}>;


export type ChangesetDiffQuery = { readonly changeset: (
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id' | 'createdAt' | 'canDelete' | 'canEdit'>
    & { readonly project: (
      { readonly __typename: 'InternshipProject' }
      & Pick<Types.InternshipProject, 'id'>
      & { readonly changeset?: Types.Maybe<(
        { readonly __typename?: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      )> }
    ) | (
      { readonly __typename: 'MomentumTranslationProject' }
      & Pick<Types.MomentumTranslationProject, 'id'>
      & { readonly changeset?: Types.Maybe<(
        { readonly __typename?: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      )> }
    ) | (
      { readonly __typename: 'MultiplicationTranslationProject' }
      & Pick<Types.MultiplicationTranslationProject, 'id'>
      & { readonly changeset?: Types.Maybe<(
        { readonly __typename?: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      )> }
    ), readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'createdAt' | 'id'>
        & { readonly amount: (
          { readonly __typename?: 'SecuredFloatNullable' }
          & Pick<Types.SecuredFloatNullable, 'canEdit' | 'canRead' | 'value'>
        ), readonly preApprovedAmount: (
          { readonly __typename?: 'SecuredFloatNullable' }
          & Pick<Types.SecuredFloatNullable, 'value' | 'canEdit' | 'canRead'>
        ), readonly initialAmount: (
          { readonly __typename?: 'SecuredFloatNullable' }
          & Pick<Types.SecuredFloatNullable, 'value' | 'canEdit' | 'canRead'>
        ), readonly fiscalYear: (
          { readonly __typename?: 'SecuredInt' }
          & Pick<Types.SecuredInt, 'canEdit' | 'canRead' | 'value'>
        ), readonly organization: (
          { readonly __typename?: 'SecuredOrganization' }
          & Pick<Types.SecuredOrganization, 'canEdit' | 'canRead'>
          & { readonly value?: Types.Maybe<(
            { readonly __typename?: 'Organization' }
            & Pick<Types.Organization, 'id' | 'createdAt'>
            & { readonly name: (
              { readonly __typename?: 'SecuredString' }
              & Pick<Types.SecuredString, 'canEdit' | 'canRead' | 'value'>
            ) }
          )> }
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly status: (
          { readonly __typename?: 'SecuredEngagementStatus' }
          & Pick<Types.SecuredEngagementStatus, 'value' | 'canRead'>
        ), readonly intern: (
          { readonly __typename?: 'SecuredUser' }
          & { readonly value?: Types.Maybe<(
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName'>
          )> }
        ), readonly countryOfOrigin: (
          { readonly __typename?: 'SecuredLocation' }
          & { readonly value?: Types.Maybe<(
            { readonly __typename?: 'Location' }
            & Pick<Types.Location, 'id'>
            & { readonly name: (
              { readonly __typename?: 'SecuredString' }
              & Pick<Types.SecuredString, 'value'>
            ) }
          )> }
        ), readonly position: (
          { readonly __typename?: 'SecuredInternPosition' }
          & Pick<Types.SecuredInternPosition, 'value'>
        ), readonly dateRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'end'>
          ) }
        ), readonly initialEndDate: (
          { readonly __typename?: 'SecuredDateNullable' }
          & Pick<Types.SecuredDateNullable, 'value'>
        ), readonly completeDate: (
          { readonly __typename?: 'SecuredDateNullable' }
          & Pick<Types.SecuredDateNullable, 'value'>
        ), readonly marketable: (
          { readonly __typename?: 'SecuredBoolean' }
          & Pick<Types.SecuredBoolean, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { projectStatus: Types.InternshipProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly status: (
          { readonly __typename?: 'SecuredEngagementStatus' }
          & Pick<Types.SecuredEngagementStatus, 'value' | 'canRead'>
        ), readonly language: (
          { readonly __typename?: 'SecuredLanguage' }
          & { readonly value?: Types.Maybe<(
            { readonly __typename?: 'Language' }
            & Pick<Types.Language, 'id' | 'avatarLetters' | 'sensitivity'>
            & { readonly displayName: (
              { readonly __typename?: 'SecuredString' }
              & Pick<Types.SecuredString, 'value'>
            ), readonly population: (
              { readonly __typename?: 'SecuredIntNullable' }
              & Pick<Types.SecuredIntNullable, 'value'>
            ), readonly registryOfLanguageVarietiesCode: (
              { readonly __typename?: 'SecuredStringNullable' }
              & Pick<Types.SecuredStringNullable, 'value'>
            ), readonly ethnologue: (
              { readonly __typename?: 'EthnologueLanguage' }
              & { readonly code: (
                { readonly __typename?: 'SecuredStringNullable' }
                & Pick<Types.SecuredStringNullable, 'canRead' | 'canEdit' | 'value'>
              ) }
            ) }
          )> }
        ), readonly products: (
          { readonly __typename?: 'SecuredProductList' }
          & Pick<Types.SecuredProductList, 'total'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { projectStatus: Types.MomentumTranslationProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { projectStatus: Types.MultiplicationTranslationProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id' | 'createdAt'>
        & { readonly types: (
          { readonly __typename?: 'SecuredPartnerTypes' }
          & Pick<Types.SecuredPartnerTypes, 'value' | 'canEdit' | 'canRead'>
        ), readonly agreementStatus: (
          { readonly __typename?: 'SecuredPartnershipAgreementStatus' }
          & Pick<Types.SecuredPartnershipAgreementStatus, 'value' | 'canEdit' | 'canRead'>
        ), readonly mouStatus: (
          { readonly __typename?: 'SecuredPartnershipAgreementStatus' }
          & Pick<Types.SecuredPartnershipAgreementStatus, 'value' | 'canEdit' | 'canRead'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & Pick<Types.SecuredDateRange, 'canRead' | 'canEdit'>
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly primary: (
          { readonly __typename?: 'SecuredBoolean' }
          & Pick<Types.SecuredBoolean, 'canRead' | 'canEdit' | 'value'>
        ), readonly partner: (
          { readonly __typename?: 'SecuredPartner' }
          & Pick<Types.SecuredPartner, 'canRead' | 'canEdit'>
          & { readonly value?: Types.Maybe<(
            { readonly __typename?: 'Partner' }
            & Pick<Types.Partner, 'id'>
            & { readonly organization: (
              { readonly __typename?: 'SecuredOrganization' }
              & Pick<Types.SecuredOrganization, 'canRead' | 'canEdit'>
              & { readonly value?: Types.Maybe<(
                { readonly __typename?: 'Organization' }
                & Pick<Types.Organization, 'id' | 'avatarLetters'>
                & { readonly name: (
                  { readonly __typename?: 'SecuredString' }
                  & Pick<Types.SecuredString, 'canRead' | 'canEdit' | 'value'>
                ) }
              )> }
            ), readonly types: (
              { readonly __typename?: 'SecuredPartnerTypes' }
              & Pick<Types.SecuredPartnerTypes, 'value'>
            ), readonly financialReportingTypes: (
              { readonly __typename?: 'SecuredFinancialReportingTypes' }
              & Pick<Types.SecuredFinancialReportingTypes, 'value'>
            ) }
          )> }
        ), readonly financialReportingType: (
          { readonly __typename?: 'SecuredFinancialReportingType' }
          & Pick<Types.SecuredFinancialReportingType, 'value' | 'canEdit' | 'canRead'>
        ), readonly mouRangeOverride: (
          { readonly __typename?: 'SecuredDateRange' }
          & Pick<Types.SecuredDateRange, 'canRead' | 'canEdit'>
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly project: (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly financialReportPeriod: (
            { readonly __typename?: 'SecuredReportPeriod' }
            & Pick<Types.SecuredReportPeriod, 'canRead' | 'canEdit' | 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly financialReportPeriod: (
            { readonly __typename?: 'SecuredReportPeriod' }
            & Pick<Types.SecuredReportPeriod, 'canRead' | 'canEdit' | 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly financialReportPeriod: (
            { readonly __typename?: 'SecuredReportPeriod' }
            & Pick<Types.SecuredReportPeriod, 'canRead' | 'canEdit' | 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly amount: (
          { readonly __typename?: 'SecuredFloatNullable' }
          & Pick<Types.SecuredFloatNullable, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { projectStatus: Types.InternshipProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { projectStatus: Types.MomentumTranslationProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { projectStatus: Types.MultiplicationTranslationProject['status'] }
        & { readonly name: (
          { readonly __typename?: 'SecuredString' }
          & Pick<Types.SecuredString, 'value'>
        ), readonly mouRange: (
          { readonly __typename?: 'SecuredDateRange' }
          & { readonly value: (
            { readonly __typename?: 'DateRange' }
            & Pick<Types.DateRange, 'start' | 'end'>
          ) }
        ), readonly step: (
          { readonly __typename?: 'SecuredProjectStep' }
          & Pick<Types.SecuredProjectStep, 'value'>
        ), readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly amount: (
            { readonly __typename?: 'SecuredFloatNullable' }
            & Pick<Types.SecuredFloatNullable, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { projectStatus: Types.InternshipProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { projectStatus: Types.MomentumTranslationProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { projectStatus: Types.MultiplicationTranslationProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly amount: (
            { readonly __typename?: 'SecuredFloatNullable' }
            & Pick<Types.SecuredFloatNullable, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { projectStatus: Types.InternshipProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { projectStatus: Types.MomentumTranslationProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { projectStatus: Types.MultiplicationTranslationProject['status'] }
          & { readonly name: (
            { readonly __typename?: 'SecuredString' }
            & Pick<Types.SecuredString, 'value'>
          ), readonly mouRange: (
            { readonly __typename?: 'SecuredDateRange' }
            & { readonly value: (
              { readonly __typename?: 'DateRange' }
              & Pick<Types.DateRange, 'start' | 'end'>
            ) }
          ), readonly step: (
            { readonly __typename?: 'SecuredProjectStep' }
            & Pick<Types.SecuredProjectStep, 'value'>
          ), readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ), readonly types: (
      { readonly __typename?: 'SecuredProjectChangeRequestTypes' }
      & Pick<Types.SecuredProjectChangeRequestTypes, 'value' | 'canRead' | 'canEdit'>
    ), readonly summary: (
      { readonly __typename?: 'SecuredString' }
      & Pick<Types.SecuredString, 'value' | 'canRead' | 'canEdit'>
    ), readonly status: (
      { readonly __typename?: 'SecuredProjectChangeRequestStatus' }
      & Pick<Types.SecuredProjectChangeRequestStatus, 'value' | 'canRead' | 'canEdit'>
    ) }
  ) };


export const ChangesetDiffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangesetDiff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"difference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetDiff"}},{"kind":"Field","name":{"kind":"Name","value":"removed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LanguageEngagementListItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternshipEngagementListItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartnershipCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartnershipForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BudgetRecord"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectChangeRequestListItem"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectChangeRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangesetId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangesetAware"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changeset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Id"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectChangesetDiff"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"step"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projectStatus"},"name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BudgetRecordChangesetDiff"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BudgetRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangesetDiffItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectChangesetDiff"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BudgetRecordChangesetDiff"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"securedDateRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecuredDateRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PartnershipToCheckBudgetChange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Partnership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"securedDateRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangesetDiff"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangesetDiff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"added"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetDiffItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetDiffItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetDiffItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetDiffItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LanguageEngagementListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"population"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registryOfLanguageVarietiesCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ethnologue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarLetters"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternshipEngagementListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternshipEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialEndDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completeDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PartnershipCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Partnership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreementStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"securedDateRange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarLetters"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialReportingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PartnershipForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Partnership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreementStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mouRangeOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"securedDateRange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarLetters"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialReportingTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialReportingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"financialReportPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartnershipToCheckBudgetChange"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BudgetRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BudgetRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preApprovedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fiscalYear"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectChangeRequestListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectChangeRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}}]} as unknown as DocumentNode<ChangesetDiffQuery, ChangesetDiffQueryVariables>;